import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionImages = _resolveComponent("TransitionImages")!
  const _component_DisplayType = _resolveComponent("DisplayType")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["hero", `hero--template-order-${_ctx.templateOrder}`]),
    ref: "heroRef"
  }, [
    _createVNode(_component_TransitionImages, { images: _ctx.images }, null, 8, ["images"]),
    _createVNode(_component_DisplayType, {
      class: "hero__title",
      line1: _ctx.line1,
      line1MaskHeight: _ctx.line1MaskHeight,
      line1Indent: _ctx.line1Indent,
      line2: _ctx.line2,
      line2MaskHeight: _ctx.line2MaskHeight,
      line2Indent: _ctx.line2Indent,
      line3: _ctx.line3,
      line3MaskHeight: _ctx.line3MaskHeight,
      line3Indent: _ctx.line3Indent,
      line4: _ctx.line4,
      line4MaskHeight: _ctx.line4MaskHeight,
      line4Indent: _ctx.line4Indent
    }, null, 8, ["line1", "line1MaskHeight", "line1Indent", "line2", "line2MaskHeight", "line2Indent", "line3", "line3MaskHeight", "line3Indent", "line4", "line4MaskHeight", "line4Indent"]),
    _createVNode(_component_Icon, {
      class: "hero__scroll_indicator",
      type: "scroll-indicator"
    })
  ], 2))
}